<template>
  <div class="sidebar">
    <div class="sidebar-wrapper">
      <div class="logo">
        <router-link to="/" class="simple-text logo-mini">
          {{ appName.abbr() }}
        </router-link>
        <router-link to="/" class="simple-text logo-normal">
          {{ appName }}
        </router-link>
      </div>
      <ul class="nav">
        <router-link :to="{name: 'CatalogManager'}" tag="li" active-class="active">
          <a href="">
            <i class="fas fa-tags"></i>
            <p>Catalog Manager</p>
          </a>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    appName(){
      return this.$store.getters.apps[this.$route.params.id]
    }
  }
}
</script>
